export default __webpack_public_path__ + "images/image-icon.cf4fe3e069518e174f129b9bac5f6e7a.svg";